import { render, staticRenderFns } from "./DataDetailService.vue?vue&type=template&id=0c20b3e0&scoped=true"
import script from "./DataDetailService.vue?vue&type=script&lang=js"
export * from "./DataDetailService.vue?vue&type=script&lang=js"
import style0 from "./DataDetailService.vue?vue&type=style&index=0&id=0c20b3e0&prod&lang=scss&scoped=true"
import style1 from "./DataDetailService.vue?vue&type=style&index=1&id=0c20b3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20b3e0",
  null
  
)

export default component.exports